import React from "react";
import ModernVideoForm from "./ModernVideoForm";

interface Props {
  singleVideo?: boolean;
}

export default function VideoForm(props: Props) {
  return <ModernVideoForm {...props} />;
}